import { doc, onSnapshot } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { db } from '../../backend/firebase'
import Header from '../../components/Header'
import Dataset from '../../components/Dataset'
import './PublicCollection.css'

const PublicCollection = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [collectionData, setCollectionData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const collectionRef = doc(db, "collections", id)
    
    const unsubscribe = onSnapshot(
      collectionRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data()
          // Check if collection is actually public
          if (data.isPrivate) {
            setError("This collection is private and cannot be accessed publicly")
          } else {
            setCollectionData(data)
            setError(null)
          }
        } else {
          setError("Collection not found")
        }
        setLoading(false)
      },
      (err) => {
        console.error("Error fetching collection:", err)
        setError("Failed to load collection data")
        setLoading(false)
      }
    )

    return () => unsubscribe()
  }, [id])

  if (loading) {
    return (
      <div className="collection-screen public-collection">
        <Header />
        <div className="collection-loading">
          <div className="collection-spinner"></div>
          <p>Loading collection...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="collection-screen public-collection">
        <Header />
        <div className="collection-error">
          <p className="error-message">{error}</p>
          <button 
            onClick={() => navigate('/')}
            className="home-button"
          >
            Go to Home
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="collection-screen public-collection">
      {/* Collection Header */}
      <div className="collection-header">
        <div className="collection-info">
          <div className="collection-avatar">
            {collectionData.collectionName?.[0]?.toUpperCase() || 'C'}
          </div>
          <div className="collection-details">
            <h1 className="collection-title">{collectionData.collectionName || 'Unnamed Collection'}</h1>
            <p className="collection-description">
              {collectionData.description || 'No description provided'}
            </p>
          </div>
        </div>
        <span className={`privacy-badge ${collectionData.isPrivate ? 'private' : 'public'}`}>
          {collectionData.isPrivate ? "Private" : "Public"}
        </span>
      </div>
      
      {/* Collection Content */}
      <div className="collection-content">
        {collectionData?.datasets?.length > 0 ? (
          <>
            <div className="datasets-header">
              <h3 className="datasets-title">Datasets in Collection</h3>
            </div>
            <div className="datasets-grid">
              {collectionData.datasets.map((dataset, index) => (
                <Dataset key={`dataset-${index}`} datasetid={dataset} />
              ))}
            </div>
          </>
        ) : (
          <div className="empty-collection">
            <h3 className="empty-title">This collection is empty</h3>
            <p className="empty-description">
              No datasets have been added to this collection yet
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default PublicCollection